export const GET_APPLICATIONS = "GET_APPLICATIONS";
export const GET_COMBINE_APPLICATIONS = "GET_COMBINE_APPLICATIONS";
export const GET_DASHBOARD_ANALYTICS = "GET_DASHBOARD_ANALYTICS";
export const GET_FILES = "GET_FILES";
export const DELETE_FILE = "DELETE_FILE";
export const GET_FIM = "GET_FIM";
export const GET_DEVICE_USERS = "GET_DEVICE_USERS";
